import { PostalAddress } from './PostalAddress';
import { GeoAddress } from '../GeoAddress';
import { OpeningHours } from './OpeningHours';

export interface LocationDTO {
  ou?: string;
  ouEntity?: string;
  locationNumber?: string;
  postalAddress?: PostalAddress;
  geoAddress?: GeoAddress;
  email?: string;
  clientParking?: boolean;
  elevator?: boolean;
  handicapAccess?: boolean;
  locationType?: LocationDTO.LocationTypeEnum;
  phoneNumber?: string;
  openingHours?: OpeningHours;
  deleted?: boolean;
  lastModifed?: string;
  commune?: string;
  champsVerrouillables?: string[]
}
export namespace LocationDTO {
  export type LocationTypeEnum = 'principal' | 'annexe';
  export const LocationTypeEnum = {
    MAIN: 'principal' as LocationTypeEnum,
    ANNEX: 'annexe' as LocationTypeEnum,
  };
}
